export class Menu {
	constructor() {
		this.body = document.querySelector('body')
		this.menu = document.querySelector('.js-menu')
		this.trigger = document.querySelector('.js-menu-trigger')
		this.item = this.menu.querySelectorAll('a.link')
		this.itemArr = Array.prototype.slice.call(this.item)
		this.menuList = document.querySelector('.js-menu-list')
		this.message = document.querySelector('.js-menu-message')

		this.trigger.addEventListener('click', (e) => {
			this.openAndClose();
		})

		this.itemArr.forEach(item => {
			item.addEventListener('click', () => {
				this.openAndClose();
			})
		});

		this.message.addEventListener('click', () => {
			this.closeAcd();
		})
	}

	openAndClose() {
		this.body.classList.toggle('fixed')
		this.menu.classList.toggle('active')
	}

	closeAcd() {
		this.menuList.classList.add('hide')
		setTimeout(() => {
			this.menuList.classList.remove('hide')
		},100)
	}
}